import React from 'react';
import PropTypes from 'prop-types';
import InnerHTML from '@Components/InnerHTML';
import DocumentHitsFormat from '@Components/Results/services/document-hits-format.service';
import { Card } from '@els/els-react--card';
import { ButtonWithIcon } from '@els/els-react--button';

function DocumentAbstractHit({ abstractText, closeClick, trackingAttrs }) {
  const abstractHit = DocumentHitsFormat.checkAndFormatHit(abstractText, 'abstract');
  return abstractHit ? (
    <Card className="result-detail-panel u-els-margin-top-1o2 e2e-document-action-abstract-hit">
      <div className="result-detail-panel-wrapper u-els-display-flex">
        <h4 className="u-els-margin-right-1o2 u-els-font-family-bold">Abstract hit:</h4>
        <div className="u-els-display-flex">
          <InnerHTML tag="div" className="u-els-font-size-base u-els-line-height-default" html={abstractHit} />
          <ButtonWithIcon
            type="link"
            data-e2e="abstract-hit-close"
            iconOnly
            linkIconSize="s"
            linkOptions={['navigation']}
            sprite="ChevronDown"
            {...trackingAttrs}
            className="result-detail-panel-wrapper-close e2e-close"
            data-automationid="sub-menu-close"
            onClick={() => {
              closeClick();
            }}>
            close
          </ButtonWithIcon>
        </div>
      </div>
    </Card>
  ) : null;
}

DocumentAbstractHit.propTypes = {
  abstractText: PropTypes.string.isRequired,
  closeClick: PropTypes.func.isRequired,
  trackingAttrs: PropTypes.object.isRequired,
};

export default DocumentAbstractHit;
